import { render, staticRenderFns } from "./venue.vue?vue&type=template&id=1afacaad&scoped=true"
import script from "./venue.vue?vue&type=script&lang=js"
export * from "./venue.vue?vue&type=script&lang=js"
import style0 from "./venue.vue?vue&type=style&index=0&id=1afacaad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afacaad",
  null
  
)

export default component.exports